import { Label } from "../atoms/label";
import { BlackCheckBox } from "../atoms/blackCheckBox";

export const CheckboxInstitutionForm = (props) => {
    const { divStyle, labelAreaStyle, title, data, checkAreaStyle, checkAreaDetailStyle, onChangeFullCheck, onChange } = props;

    return (
        <div style={divStyle}>
            <Label style={labelAreaStyle} label={title}/>
            <BlackCheckBox checkAreaStyle={checkAreaStyle} id={"grundy"} item={"全選択"} defaultChecked={data.filter((d)=>{ return d.checked }).length ? true : false} onChange={onChangeFullCheck}/>
            {data.map((d, index) => (
                <BlackCheckBox 
                    checkAreaStyle={checkAreaDetailStyle} 
                    key={index} 
                    id={d.value} 
                    className={d.class}
                    onChange={onChange}
                    item={d.value} 
                    value={d.id} 
                    defaultChecked={d.checked} />
            ))}
        </div>
    );
};